<script lang="ts" setup>
import {useCartStore} from "@/stores/cart";

const cartStore = useCartStore()

const props = defineProps<{ productId: number, price?: number | string }>()
</script>

<template>
  <div class="flex flex-row gap-2.5 w-full bg-white border font-semibold text-[20px] leading-[18px] px-2.5">
    <button class="text-3xl transition-colors hover:text-[hsl(var(--roke-text-blue))]" type="button" @click="cartStore.decrementItemCount(props.productId, props.price)">–</button>
    <input :value="cartStore.getItemCountById(props.productId)" class="w-full text-center outline-none" @input="cartStore.addToCart(props.productId, props.price, +($event.target as HTMLInputElement).value)"/>
    <button class="text-3xl transition-colors hover:text-[hsl(var(--roke-text-blue))]" type="button" @click="cartStore.incrementItemCount(props.productId, props.price)">+</button>
  </div>
</template>